import type { FrameworkConfig, ProjectConfig } from "../../types/types.js"
import { BaseFramework } from "../base-framework.js"

const svelteConfig: FrameworkConfig = {
  defaultMeta: "sveltekit",
  displayName: "Svelte",
  metaFrameworks: ["sveltekit", "none"],
  name: "svelte",
  starter: {
    args: (config: ProjectConfig) => {
      const args: Array<string> = []
      if (config.typescript) {
        args.push("--types", "typescript")
      } else {
        args.push("--types", "null")
      }
      return args
    },
    command: "create-svelte",
  },
}

export class SvelteFramework extends BaseFramework {
  constructor() {
    super(svelteConfig)
  }

  getStarterCommand(projectConfig: ProjectConfig): string {
    const { metaFramework } = projectConfig

    switch (metaFramework) {
      case "sveltekit":
        return this.getSvelteKitCommand(projectConfig)
      case "none":
        return this.getViteSvelteCommand(projectConfig)
      default:
        return this.getViteSvelteCommand(projectConfig)
    }
  }

  private getSvelteKitCommand(projectConfig: ProjectConfig): string {
    const { projectName, typescript } = projectConfig
    const args = [
      projectName,
      "--no-install",
      typescript ? "--types typescript" : "--types null",
      "--template skeleton",
      "--no-prettier",
      "--no-eslint",
      "--no-playwright",
      "--no-vitest",
    ]

    return `npm create svelte@latest ${args.join(" ")}`
  }

  private getViteSvelteCommand(projectConfig: ProjectConfig): string {
    const { projectName, typescript } = projectConfig
    const template = typescript ? "svelte-ts" : "svelte"

    return `npm create vite@latest ${projectName} -- --template ${template}`
  }

  getPostInstallTasks(
    projectConfig: ProjectConfig,
  ): Array<() => Promise<void>> {
    const tasks: Array<() => Promise<void>> = []

    // Add Svelte-specific post-install tasks
    if (projectConfig.metaFramework === "sveltekit") {
      tasks.push(async () => {
        // SvelteKit specific setup
        await this.updatePackageJson(projectConfig, {
          scripts: {
            build: "vite build",
            check: "svelte-kit sync && svelte-check --tsconfig ./tsconfig.json",
            dev: "vite dev",
            preview: "vite preview",
          },
        })
      })
    }

    return tasks
  }
}
